import rehypeParse from 'rehype-parse';
import rehypeRemark from 'rehype-remark';
import remarkHtml from 'remark-html';
import remarkParse from 'remark-parse';
import remarkStringify from 'remark-stringify';
import remarkGfm from 'remark-gfm';
import { unified } from 'unified';
import { DOMDocumentOptions, DOMParserOptions, JSONParserOptions, nodeFromHTML } from '@prosekit/core';
import { remarkLinkProtocol } from './remarkLinkProtocol';

// By default, remark-stringify escapes underscores (i.e. "_" => "\_"). We want
// to disable this behavior so that we can have underscores in mention handles.
const unescapeUnderscore = (str: string) => str.replace(/(^|[^\\])\\_/g, '$1_');

export const markdownFromHTML = (html: string): string => {
  const markdown = unified()
    .use(rehypeParse)
    .use(rehypeRemark)
    .use(remarkLinkProtocol)
    .use(remarkStringify)
    .processSync(html)
    .toString();

  return unescapeUnderscore(markdown);
};

export const htmlFromMarkdown = (markdown: string): string =>
  unified()
    .use(remarkParse)
    // using remark-gfm to support auto links on plain string in markdown (GitHub Flavored Markdown syntax)
    .use(remarkGfm)
    .use(remarkHtml)
    .processSync(markdown)
    .toString();

export const parseTitle = (title: string, options: DOMParserOptions & JSONParserOptions & DOMDocumentOptions) =>
  nodeFromHTML(`<h1>${title}</h1>`, options);
